import { createFileRoute } from '@tanstack/react-router'
import { CREATE_ACCESS } from '../../../app/access'
import { requireAccess } from '../../../app/guards'
import { treasuryOptionsQueryOptions } from '../../../features/sales/queries'
import { NewReceiptPage } from '../../../features/sales/receipt-pages'
import { newReceiptSearchSchema } from '../../../features/sales/search'

export const Route = createFileRoute('/_app/receipts/new')({
  staticData: { crumb: 'receiptNew' },
  validateSearch: newReceiptSearchSchema,
  beforeLoad: ({ context }) => requireAccess(context.session, CREATE_ACCESS.receipt),
  loader: ({ context }) => {
    // Warm the cash/bank picker; the form does not wait for it.
    void context.queryClient.prefetchQuery(treasuryOptionsQueryOptions)
  },
  component: NewReceiptPage,
})
